{
    "Action.AddComment": "Legg til kommentar",
    "Action.Close": "Lukk",
    "Action.CloseAll": "Lukk alle",
    "Action.ClosePanel": "Lukk panel",
    "Action.CloseTab": "Lukk fane",
    "Action.DeleteComment": "Slette kommentar",
    "Action.DeleteFilling": "Slett utfylling",
    "Action.DuplicateFilling": "Duplisér utfylling",
    "Action.EditComment": "Endre kommentar",
    "Action.EditFilling": "Rediger utfylling",
    "Action.ExpandTitle": "Utvid {{title}}",
    "Action.Generate": "Generer",
    "Action.GenerateChecklist": "Generer sjekkliste",
    "Action.GenerateTemplates": "Generer maler",
    "Action.GenerateToWord": "<small-1>Generer til<\/small-1> Word",
    "Action.NameFilling": "Navngi utfylling",
    "Action.NewFilling": "Ny utfylling",
    "Action.OpenAll": "Åpne alle",
    "Action.OpenFilling": "Åpne utfylling",
    "Action.OpenInDib": "Åpne i dib",
    "Action.OpenMenu": "Åpne meny",
    "Action.Reset": "Tilbakestill",
    "Action.ResetFields": "Nullstill felter",
    "Action.Save": "Lagre",
    "Action.SendToDflow": "<small-1>Send til<\/small-1> dflow",
    "Action.WriteAComment": "Skriv en kommentar",
    "Dashboard.pin": "Fest innhold",
    "Dashboard.pinToTop": "Fest til toppen",
    "Dashboard.removeFavorite.title": "Fjern fra favoritter",
    "Dashboard.removeFromTop": "Fjern fra toppen",
    "Dashboard.unpin": "Fjern festet innhold",
    "Dashboard.unpin.confirm.title": "Fjerne festet innhold?",
    "DocumentGenerator.Alternative": "Alternativ",
    "DocumentGenerator.ChooseAlternative": "Velg et alternativ",
    "DocumentGenerator.OptionalContent": "Valgfritt innhold",
    "Error.404Description": "Siden du spurte etter finnes ikke",
    "Error.FetchFillings": "Kunne ikke hente utfyllinger",
    "Error.NoFillingAccess": "Du har ikke tilgang til denne utfyllingen",
    "Error.NotFound": "Ikke funnet",
    "Error.SomethingWentWrong": "Noe gikk galt",
    "Error.TryReloadingOrContactUs": "Prøv å laste siden på nytt og <span-1><a-1>kontakt oss<\/a-1> hvis problemet vedvarer.<\/span-1>",
    "Error.UnknownArtifact": "422 Innholdet kan ikke vises",
    "Info.ChooseADocumentToTheLeft": "Velg et dokument til venstre",
    "Info.DataToDuplicate": "Data som skal dupliseres",
    "Info.FillingWithoutName": "Utfylling uten navn",
    "Info.GenerationNotAvailableForDemoUsers": "Generering er ikke tilgjengelig for demobrukere.",
    "Info.IncludeInGeneration": "Inkludér i generering",
    "Info.MergeDocuments": "Slå sammen valgte dokumenter til én pdf.",
    "Info.NoAvailableDocuments": "Ingen tilgjengelige dokumenter",
    "Info.NoHits": "Ingen treff",
    "Info.RemoveFromGeneration": "Fjern fra generering",
    "Label.ConfirmAction": "Bekreft handling",
    "Label.DIBStandardTemplate": "DIB Standardmal",
    "Label.DuplicateName": "Navn på duplikat",
    "Label.MarkAllAsStatus": "Markér hele kategorien som {{status}}",
    "Label.ShowLess": "Vis mindre",
    "Label.ShowMore": "Vis mer",
    "Navigation.Lookup": "Oppslag",
    "Phrase.AsEmailAttachment": "Som vedlegg i e-post",
    "Phrase.AvailableOnDib": "Tilgjengelig på dib",
    "Phrase.ChooseStyleTemplate": "Velg stilmal",
    "Phrase.ChooseStyleTemplatePrompt": "Velg en stilmal",
    "Phrase.DeliveredAs": "Leveres som",
    "Phrase.DownloadFile": "Last ned {{file}}",
    "Phrase.DuplicateOfTitle": "Duplikat av {{fillingTitle}}",
    "Phrase.FieldsInDocumentGenerator": "Felter i dokumentgenerator",
    "Phrase.InAWordDocument": "I et Word-dokument",
    "Phrase.IncludeInstructions": "Inkluder veiledning",
    "Phrase.LastEdited": "Sist endret",
    "Phrase.LoadingModal": "Laster...",
    "Phrase.NoAccess": "Ingen tilgang",
    "Phrase.NoPreviousFillings": "Ingen tidligere utfyllinger",
    "Phrase.NoResultsOn": "Ingen resultater på",
    "Phrase.NoSearchResults": "Ingen treff",
    "Phrase.NoTemplatesChosen": "Ingen maler er valgt",
    "Phrase.RemoveFilters": "Fjern filtre",
    "Phrase.SearchFilling": "Søk utfylling",
    "Phrase.SendToDflow": "Send til dflow",
    "Phrase.ShowMore": "Vis flere",
    "Phrase.SorryYouDoNotHaveAccessToContent": "<strong-1>Beklager<\/strong-1>, du har ikke tilgang til dette innholdet.",
    "Prompt.WouldYouLikeToDeleteFilling": "Vil du slette utfyllingen <strong-1>{{fillingTitle}}<\/strong-1>?",
    "Status.Deviation": "Avvik",
    "Status.NA": "Ikke aktuelt",
    "Status.Ok": "OK",
    "Status.Todo": "Ubesvart",
    "Status.WithComment": "Med kommentar",
    "Title.LabelOfContents": "Innholdsfortegnelse",
    "Title.RelatedContent": "Relatert",
    "Title.TemplatesWithCount": "Maler ({{selectedDocsLength}})",
    "Type.AuditTemplate": "Revisormal",
    "Type.ChartOfAccounts": "Kontoplan",
    "Type.ChecklistTemplates": "Sjekkliste \/ Maler",
    "Type.Decision": "Avgjørelse",
    "Type.Directive": "Direktiv",
    "Type.Function": "Funksjon",
    "Type.Handbook": "Håndbok",
    "Type.JuridiskVejledning": "Juridisk Vejledning",
    "Type.Law": "Lov",
    "Type.LegalCommentary": "Lovkommentar",
    "Type.Literature": "Faglitteratur",
    "Type.Nature": "Art",
    "Type.News": "Nyhet",
    "Type.PortalReference": "Portal",
    "Type.PortalSources": "Portal",
    "Type.PortalTools": "Portal",
    "Type.Praktika": "Praktika",
    "Type.PreparatoryWorks": "Forarbeid",
    "Type.Q&A": "Q&A",
    "Type.Regulation": "Forskrift",
    "Type.SkatteABC": "Skatte-ABC",
    "Type.Spreadsheet": "Regneark \/ Regnskap",
    "Type.Standard": "Standard",
    "Type.Statement": "Uttalelse",
    "Type.TaxTreaty": "Skatteavtale",
    "Type.Template": "Dokumentmal",
    "Type.Topic": "Tema",
    "Type.Unknown": "Annet",
    "Warn.DataToDuplicateNotChosen": "Du har ikke valgt noe data for duplisering",
    "Warning.AboutToMarkAllChecklistItems": "Du er i ferd med å markere alle sjekkpunkter i denne kategorien som <strong>{{status}}<\/strong>. Er du sikker?",
    "Widget.audit.process.title": "Revisjon - Maler og Sjekklister",
    "Widget.content.description": "Innhold i dib jeg har besøkt",
    "Widget.content.none": "Ingenting her.. Det vil dukke opp ting så fort du åpner innhold",
    "Widget.content.title": "Sist besøkt",
    "Widget.favourites.title": "Mine favoritter",
    "Widget.fillings.description": "Maler og sjekklister jeg jobber med",
    "Widget.fillings.none": "Ingen utfyllinger her... Begynn å fylle sjekklister og maler så dukker det opp ting her.",
    "Widget.fillings.title": "Utfyllinger",
    "Widget.internal.portal.allAreas": "Alle områder",
    "Widget.internal.portal.content": "Innhold",
    "Widget.internal.portal.history": "Historikk",
    "Widget.internal.portal.history.none": "Innhold du åpner dukker opp her.",
    "Widget.internal.portal.myWork": "Mitt arbeid",
    "Widget.internal.portal.myWork.none": "Lagrede utfyllinger på vil vises her",
    "Widget.internal.portal.pinned": "Festet",
    "Widget.internal.portal.title": "Portaler",
    "Widget.internal.templates.title": "Siste maler",
    "Widget.last.threads.none": "Dine samtaler og søk vil dukke opp her",
    "Widget.last.threads.title": "Siste tråder",
    "Widget.latest.news.title": "Nyheter",
    "Widget.threads.description": "Siste chatter\/tråder med KAI",
    "Widget.threads.none": "Ingenting her.. Når du begynner å søke\/chatte så dukker det opp ting her",
    "Widget.threads.title": "Samtaler",
    "Word.Abort": "Avbryt",
    "Word.Checklist": "Sjekkliste",
    "Word.Close": "Lukk",
    "Word.Comments": "Kommentarer",
    "Word.Confirm": "Bekreft",
    "Word.Content": "Innhold",
    "Word.Created": "Opprettet",
    "Word.DocumentType": "Dokumenttype",
    "Word.Duplicate": "Dupliser",
    "Word.Edit": "Endre",
    "Word.Email": "E-post",
    "Word.Error": "Feil",
    "Word.Filling": "Utfylling",
    "Word.Footnote": "Fotnote",
    "Word.Generate": "Generer",
    "Word.Info": "info",
    "Word.Landscape": "Liggende",
    "Word.Less": "Mindre",
    "Word.More": "Mer",
    "Word.Name": "Navn",
    "Word.New": "Ny",
    "Word.Open": "Åpne",
    "Word.PaperOrientation": "Papirretning",
    "Word.Portrait": "Stående",
    "Word.Remove": "Fjern",
    "Word.Sources": "Kilder",
    "Word.Status": "Status",
    "Word.StyleTemplate": "Stilmal",
    "Word.Template": "Mal",
    "Word.Templates": "Maler",
    "Word.TheSearchText": "Søketeksten",
    "Word.Untitled": "Uten tittel",
    "Word.ZipFile": "ZIP-fil",
    "Word.create": "Opprett",
    "action.seeLess": "Vis mindre",
    "action.seeMore": "Se flere",
    "alert.MergeConfirmBody": "Ved å krysse av for \"PDF sammenslåing\" vil alle valgte dokumenter bli slått sammen til ett PDF-dokument. De vil ikke kunne redigeres i Dflow.",
    "alert.MergeConfirmTitle": "PDF sammenslåing",
    "animation.part.0": "Spør",
    "animation.part.1": "KAI",
    "animation.part.2": "om",
    "animation.suggestion.1": "lønn og personal",
    "animation.suggestion.2": "regnskap og mva",
    "animation.suggestion.3": "innhold i dib",
    "app.title": "KAI",
    "artifact.emailDraft.copied": "Kopiert!",
    "artifact.emailDraft.copyEmail": "Kopier e-post",
    "artifact.emailDraft.empty": "Tomt e-postutkast",
    "artifact.emailDraft.openInClient": "Åpne i e-postklient",
    "artifact.emailDraft.subjectLabel": "Emne",
    "artifact.emailDraft.titleFallback": "E-postutkast",
    "artifact.emailDraft.tooLongWarning": "E-posten er for lang til å sende direkte via e-postklienten. Bruk kopier-knappen for å kopiere innholdet og lim det inn manuelt.",
    "artifact.generic.titleFallback": "Artefakt",
    "artifact.pending.titleFallback": "Utkast",
    "artifact.searchResults.noResults": "Ingen resultater for «{{query}}»",
    "artifact.searchResults.resultsFor": "Resultater for «{{query}}»",
    "artifact.searchResults.showFewer": "Vis færre",
    "artifact.searchResults.showMore": "Vis {{count}} flere resultater",
    "artifact.searchResults.titleFallback": "Søkeresultater",
    "assistant.answerHeading": "Svar fra KAI",
    "brand.name": "DIB",
    "callout.suggestplus.common.confirm": "Spør på nytt med KAI+",
    "callout.suggestplus.common.text": "Ønsker du å gjøre en dypere analyse med litt mer ventetid?",
    "callout.suggestplus.common.title": "KAI klarer ikke gi et godt nok svar",
    "chat.ephemeral_search.nudge": "Er ikke resultatene over relevante? Chat videre med meg under",
    "chat.experimentalEngineActive": "Eksperimentell motor",
    "chat.limit.body": "For å sikre at KAI gir deg presise svar, avsluttes samtaler etter 50 meldinger.",
    "chat.limit.button": "Start ny chat\/tråd",
    "chat.limit.heading": "Maksgrensen er nådd",
    "chat.multi_stream.capacity_message": "Tre samtaler er allerede under behandling. Vennligst vent til en har fullført.",
    "chat.multi_stream.capacity_title": "For mange aktive samtaler",
    "common.askQuestion": "Still et spørsmål",
    "common.cancel": "Avbryt",
    "common.closeSidebar": "Lukk sidefelt",
    "common.collapseSidebar": "Lukk sidepanel",
    "common.copied": "Kopiert",
    "common.copy": "Kopier",
    "common.defaultThreadTitle": "Ny tråd",
    "common.delete": "Slett",
    "common.disclaimer": "Svar fra KI kan inneholde feil.",
    "common.editMessage": "Rediger melding",
    "common.expandSidebar": "Åpne sidepanel",
    "common.getStarted": "Still et spørsmål for å komme i gang!",
    "common.goBack": "Gå tilbake",
    "common.loadingTranslations": "Laster oversettelser...",
    "common.malerAndChecklists": "Maler og sjekklister",
    "common.newChat": "Nytt spørsmål",
    "common.noResults": "Ingen søketreff",
    "common.openSidebar": "Åpne sidefelt",
    "common.otherContentFromDIB": "Annet innhold fra dib",
    "common.recentChats": "Nylige tråder",
    "common.recentSearches": "Sist besøkt i dib",
    "common.recentThreads": "Siste tråder",
    "common.regenerate": "Regenerér svar",
    "common.rename": "Endre navn",
    "common.save": "Lagre",
    "common.search": "Søk",
    "common.searchBox": "Spør <strong>KAI<\/strong> eller søk etter innhold",
    "common.seeAll": "Se alle",
    "common.send": "Send",
    "common.share": "Del",
    "common.showAll": "Vis alle ({{count}})",
    "common.showLess": "Vis færre",
    "common.suggestions": "Forslag",
    "common.thinking": "Tenker... AI-svar er ikke alltid feilfrie. Husk å sjekke kildene fra dib!",
    "common.tryAgain": "Prøv igjen",
    "common.visibleForAdmins": "Synlig for admins",
    "common.yesterday": "I går",
    "content.comment": "Kommentar",
    "content.lawRulesMirror": "Lov\/forskriftsspeil",
    "content.relatedSources": "Relaterte kilder",
    "content.tags": "Stikkord",
    "content.translation": "Oversettelse",
    "contextSidebar.BetaDisclaimer": "Sidepanelet er under utvikling. Vi jobber fortløpende med å hente ut gode søkeresultater fra dib.",
    "contextSidebar.OtherHeading": "Annet innhold fra dib",
    "contextSidebar.ThreadExplanation": "Chatbeskrivelse (AI-generert)",
    "contextSidebar.ToolsHeading": "Verktøy fra dib",
    "contextSidebar.closeContextSidebar": "Lukk kontekst-sidefelt",
    "contextSidebar.error": "Feil ved lasting av innhold",
    "contextSidebar.noRelatedContent": "Fant ingen relaterte temaer eller kilder i dib",
    "contextSidebar.noRelatedTemplates": "Fant ingen relaterte maler eller sjekklister i dib",
    "contextSidebar.openContextSidebar": "Åpne sidepanel",
    "date.last30Days": "Siste 30 dager",
    "date.lastWeek": "Siste uke",
    "date.previously": "Tidligere",
    "date.today": "I dag",
    "debug.addSuggestion": "Legg til forslag",
    "error.contentFilter.body": "Spørsmålet ble blokkert av innholdsfilteret. Rediger meldingen din over og prøv med andre ord.",
    "error.contentFilter.title": "Innholdsfiltrering",
    "error.contextLength.body": "Chatten har vokst seg for lang.",
    "error.contextLength.title": "Chat for lang",
    "error.filteredContent.body": "The response was filtered due to the prompt triggering our content management policy. Please modify your prompt and retry.",
    "error.interrupted.body": "Det forrige svaret ble ikke fullført. Prøv spørsmålet på nytt for å få et nytt svar.",
    "error.interrupted.title": "Svaret ble avbrutt",
    "error.rateLimit.body": "Du har nådd grensen for antall forespørsler. Vent et par minutter og prøv igjen. Dersom problemet vedvarer, kontakt brukerstøtte.",
    "error.rateLimit.title": "For mange forespørsler",
    "error.unknown.body": "En ukjent feil har oppstått under generering av svaret.",
    "error.unknown.title": "Ukjent feil",
    "file.download": "Last ned {{file}}",
    "file.downloadNotForDemo": "Filnedlasting er ikke tilgjengelig for demobrukere",
    "forbidden.description": "Beklager, du har ikke tilgang til å bruke denne applikasjonen. Vennligst kontakt oss hvis du mener dette er en feil.",
    "forbidden.title": "Tilgang nektet",
    "input.placeholder.splash": "Hva trenger du hjelp med?",
    "input.placeholder.thread": "Still et oppfølgingsspørsmål",
    "menu.item.desc.deep": "Analyserer og resonnerer mer",
    "menu.item.desc.fast": "KAI gir deg enkle, raske svar",
    "menu.item.disabledtooltip.deep": "Denne funksjonaliteten er ikke tilgjengelig for deg.",
    "menu.item.time.deep": "~20 sek",
    "menu.item.time.fast": "~10 sek",
    "menu.item.title.deep": "KAI+",
    "menu.item.title.fast": "Raske svar",
    "name.Dflow": "Dflow",
    "prompt.heading.welcome": "Hva kan jeg hjelpe deg med?",
    "rag.state.answering": "Svarer",
    "rag.state.finished": "Tenkte i {n} sekunder",
    "rag.state.finishedNoTime": "Sammendrag",
    "rag.state.idle": "Tenker",
    "rag.state.reading": "Leser innhold",
    "rag.state.searching": "Søker i kildene",
    "rag.state.summarizing": "Setter sammen relevante kilder",
    "rating.addRating": "Gi feedback",
    "rating.comment.placeholder": "Kommentar",
    "rating.editRating": "Endre feedback",
    "rating.modal.button": "Gi feedback",
    "rating.modal.cancel": "Hopp over",
    "rating.modal.category.0": "Svaret inneholder feil",
    "rating.modal.category.1": "KAI fulgte ikke instruksjonene mine",
    "rating.modal.category.2": "Jeg likte ikke strukturen i svaret",
    "rating.modal.category.3": "KAI bruker feil kilder fra dib",
    "rating.modal.category.4": "Annen feedback",
    "rating.modal.category.5": "Utdatert informasjon",
    "rating.modal.description": "Velg en kategori under. Takk for at du hjelper oss å forbedre KAI.",
    "rating.modal.elaborate": "Utdyp gjerne...",
    "rating.modal.title": "Takk for din feedback",
    "rating.response.isHelpful": "Vurder svar som hjelpsomt",
    "rating.response.isNotHelpful": "Vurder svar som ikke hjelpsomt",
    "rating.submit": "Send",
    "rating.text": "Legg igjen en kommentar",
    "references.consideredSources.title": "I tillegg søkte KAI gjennom disse kildene:",
    "references.consideredSources.tooltip": "Vis andre overveide kilder",
    "references.relatedTools.title": "Foreslåtte verktøy",
    "references.title": "Svaret er basert på disse kildene fra DIB",
    "reflections.button.text": "Refleksjoner",
    "reflections.button.text.loading": "Analyserer spørsmålet",
    "rename.modal.label": "Nytt navn",
    "rename.modal.title": "Endre navn på tråd",
    "sessionExpired.description": "Sesjonen din ble avsluttet, og vi klarte ikke å starte den på nytt automatisk. Prøv å logge inn igjen. Hvis dette fortsetter, vennligst kontakt support.",
    "sessionExpired.signOut": "Logg ut",
    "sessionExpired.title": "Sesjonen er utløpt",
    "settings.accountDetails": "Kontoinformasjon",
    "settings.chatEngine": "Chat-motor",
    "settings.field.chatEngine.experimental": "Eksperimentell",
    "settings.field.chatEngine.standard": "Standard",
    "settings.field.company.description": "Ditt firma",
    "settings.field.company.title": "Virksomhet",
    "settings.field.email.description": "Din e-post",
    "settings.field.email.title": "E-post",
    "settings.field.name.description": "Ditt fulle navn",
    "settings.field.name.title": "Navn",
    "settings.field.response.deep": "KAI+",
    "settings.field.response.fast": "Rask",
    "settings.field.sidebarPosition.left": "Venstre",
    "settings.field.sidebarPosition.right": "Høyre",
    "settings.language": "Språk",
    "settings.logout": "Logg ut",
    "settings.preferences": "Innstillinger",
    "settings.responseType": "Forhåndsvalgt svartype",
    "settings.showInternalFeatures": "Vis admin funksjonalitet",
    "settings.sidebarPosition": "Kontekst-sidefelt posisjon",
    "settings.title": "Innstillinger",
    "suggestionQuestion.1": "Kan et selskap frivillig registreres for utleie av tomt?",
    "suggestionQuestion.2": "Hvor lenge kan en arbeidstaker være permittert?",
    "table.close": "Lukk",
    "table.expand": "Utvid",
    "table.fullscreenTitle": "Lukk fullskjerm med krysset helt til høyre, eller trykk <span>Esc<\/span> tasten.",
    "table.openFullscreen": "Åpne tabell i fullskjerm",
    "thread.postsearch.filters.button": "Filter",
    "thread.postsearch.filters.otherSources": "Andre kilder",
    "thread.postsearch.filters.tools": "Verktøy",
    "thread.postsearch.note": "<strong>Treffer ikke søket som forventet?<strong><\\br> Vi jobber hele tiden med å gjøre resultatene fra DIB mer relevante",
    "thread.postsearch.resultsFor": "Søkeresultater for",
    "thread.tabs.answer": "Svar fra KAI",
    "thread.tabs.answerReady": "Svar klart",
    "thread.tabs.search": "Treff i DIB",
    "topicSidebar.OtherHeading": "Annet innhold",
    "topicSidebar.ToolsHeading": "Verktøy",
    "userinput.button.text.deep": "KAI+",
    "userinput.button.text.fast": "Rask",
    "userinput.placeholder": "Spør KAI",
    "word.Expand": "Ekspander"
}